var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showLogin)?_c('div',{staticClass:"loginDialog"},[_c('iframe',{attrs:{"src":_vm.iframeSrc,"frameborder":"0"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }